export default {
	columns: {
		headImgUrl: {
			label: '商品名称',
			visible: true,
			width: '80',
			align: 'left',
		},
		staffName: {
			label: '订单状态',
			visible: true,
			width: '80',
			align: 'left',
		},
		jobIdentityCn: {
			label: '订单金额',
			visible: true,
			width: '80',
			align: 'left',
		},
		mobile: {
			label: '数量',
			visible: true,
			width: '120',
			align: 'left',
		},
		staffNo: {
			label: '使用现金券',
			visible: true,
			width: '100',
			align: 'left',
		},
		joinTime: {
			label: '现金券券号',
			visible: true,
			width: '100',
			align: 'left',
		},
		statusCn: {
			label: '优惠金额',
			visible: true,
			width: '80',
			align: 'left',
		},
		accountStatusCn: {
			label: '付款金额',
			visible: true,
			width: '80',
			align: 'left',
		},
		auditStatusCn: {
			label: '支付方式',
			visible: true,
			width: 'auto',
			align: 'left',
    },
    auditStatusCn: {
			label: '支付时间',
			visible: true,
			width: 'auto',
			align: 'left',
    },
    auditStatusCn: {
			label: '创建时间',
			visible: true,
			width: 'auto',
			align: 'left',
		},
  },
  smsDetail: {
    content: {
      label: '内容',
      visible: true,
      width: 'auto',
      align: 'left',
    },
    smsNum: {
      label: '短信数量',
      visible: true,
      width: '300',
      align: 'left',
    },
    // leftNum: {
    //   label: '短信剩余',
    //   visible: true,
    //   width: '100',
    //   align: 'left',
    // },
    createTime: {
      label: '时间',
      visible: true,
      width: '200',
      align: 'left',
      formatDay: true
    },
  },
  detail: {
    reportDate: {
			label: '日期',
			visible: true,
			width: 'auto',
			align: 'left',
		},
		rechargeTotal: {
			label: '充值总数',
			visible: true,
			width: 'auto',
			align: 'left',
    },
		giveTotal: {
			label: '赠送总数',
			visible: true,
			width: 'auto',
			align: 'left',
    },
    sendTotal: {
			label: '发送总数',
			visible: true,
			width: 'auto',
			align: 'left',
		},
		successTotal: {
			label: '发送成功',
			visible: true,
			width: 'auto',
			align: 'left',
    },
    failTotal: {
			label: '发送失败',
			visible: true,
			width: 'auto',
			align: 'left',
		},
  }
}
